import React from "react";
import StatsUtils from "../../../../utils/stats";
import CountUp from "react-countup";

const PercentageSmallLine = props => {
  return (
    <div
      style={{
        fontWeight: "bold",
        height: props.height,
        width: props.width,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "1.5vh"
      }}
    >
      <CountUp
        start={0}
        end={StatsUtils.roundKpiValue(props.kpi, props.percentage)}
        duration={3}
        separator=" "
        decimals={props.percentage % 1 === 0 ? 0 : 2}
        formattingFn={v => {
          return StatsUtils.formatKpiValue(props.kpi, v);
        }}
        style={{
          fontSize: "15px",
          fontWeight: "bold"
        }}
      />
    </div>
  );
};

export default PercentageSmallLine;



// WEBPACK FOOTER //
// src/modules/stats/components/GraphViews/PercentageSmallLine.js